import { deleteFormInstance } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import batchRemoveFieldInstances from "./batchDeleteFieldInstances";
import prepareFieldInstanceDataForDelete from "./prepareFieldInstanceDataForDelete";
import { handleBatchCrud } from "./handleBatchCrud";
import { FormInstance } from "db/definitions";
import { recordRepairBreadcrumb } from "./recordSentry";

async function deleteFormInstanceAmplify(formInstance: FormInstance, deleteAlts: boolean, online: boolean) {
	const response = await prepareFieldInstanceDataForDelete(formInstance.fieldInstances.items, deleteAlts, online);
	// Deleting a form removes every field instance under it (cells included) and is the only in-app path that deletes
	// field instances wholesale. Record what is about to go so a later "data missing" report can be traced.
	recordRepairBreadcrumb("deleteFormInstance", {
		formInstanceId: formInstance.id,
		formGroup: formInstance.formGroup,
		formTemplateId: formInstance.formTemplateId,
		fieldInstancesToDelete: response.fieldInstances.length,
		deleteAlts,
	});

	const deleteFormInstanceData = {
		id: formInstance.id,
	};
	const client = generateClient({ authMode: "userPool" });
	await client.graphql({
		query: deleteFormInstance,
		variables: {
			input: deleteFormInstanceData,
		},
		authMode: "userPool",
	});
	handleBatchCrud(response.fieldInstances, batchRemoveFieldInstances, 25);
}

export default deleteFormInstanceAmplify;
